(() => {
  const wholesaleAccountPagePattern = /\/pages\/ws-account-(login|create)\/?$/;
  if (!wholesaleAccountPagePattern.test(window.location.pathname)) return;

  const initWholesaleAccountTranslation = () => {
    if (window.__smartdnaPrecisionWsgAccountTranslationInitialized) return;
    window.__smartdnaPrecisionWsgAccountTranslationInitialized = true;

    const normalizeText = (value) => (value || '').replace(/\s+/g, ' ').trim().toLowerCase();
    const wholesaleTextReplacements = new Map([
      ['wholesale login', 'Återförsäljarinloggning'],
      ['apply for a wholesale account', 'Ansök om företagskonto'],
      ['wholesale registration form', 'Ansök om företagskonto'],
      ['apply for account', 'Ansök om konto'],
      ['need an account?', 'Saknar du konto?'],
      ['sign up here.', 'Ansök om konto här.'],
      ['create a wholesale account', 'Ansök om företagskonto'],
      ['customer information', 'Kunduppgifter'],
      ['shipping address', 'Leveransadress'],
      ['continue', 'Fortsätt'],
      ['already have an account?', 'Har du redan ett konto?'],
      ['login here.', 'Logga in här.'],
      ['email', 'E-post'],
      ['password', 'Lösenord'],
      ['forgot your password?', 'Glömt lösenordet?'],
      ['company', 'Företag'],
      ['company name', 'Företagsnamn'],
      ['required', 'Obligatoriskt'],
      ['missing required fields', 'Obligatoriska fält saknas'],
      ['first name', 'Förnamn'],
      ['last name', 'Efternamn'],
      ['phone number', 'Telefonnummer'],
      ['phone', 'Telefon'],
      ['website', 'Webbplats'],
      ['reference', 'Referens'],
      ['tax id, abn, or vat number', 'Organisationsnummer eller VAT-nummer'],
      ['tax id/abn/vat number', 'Organisationsnummer eller VAT-nummer'],
      ['address 1', 'Adressrad 1'],
      ['address 2', 'Adressrad 2'],
      ['address line 1', 'Adressrad 1'],
      ['address line 2', 'Adressrad 2'],
      ['city', 'Ort'],
      ['country', 'Land'],
      ['state/province', 'Region'],
      ['zip/postal code', 'Postnummer'],
      ['notes', 'Meddelande'],
      ['message', 'Meddelande'],
      ['tell us a little about yourself so that we can verify your business identity.', 'Berätta kort om verksamheten så att vi kan verifiera företaget.'],
      ['submit', 'Skicka'],
      ['verfügbarkeit', 'Tillgänglighet'],
      ['availability', 'Tillgänglighet'],
      ['preis', 'Pris'],
      ['price', 'Pris'],
      ['auf lager', 'I lager'],
      ['in stock', 'I lager'],
      ['out of stock', 'Ej i lager'],
    ]);

    const wholesaleFieldOverrides = [
      { id: 'company', label: 'Företagsnamn', autocomplete: 'organization' },
      { id: 'wsg-tax-id', label: 'Organisationsnummer eller VAT-nummer' },
      { id: 'wsg-phone-number', label: 'Telefonnummer', autocomplete: 'tel' },
      { id: 'wsg-website', label: 'Webbplats', autocomplete: 'url' },
      { id: 'wsg-notes', label: 'Berätta kort om verksamheten så att vi kan verifiera företaget.' },
      { id: 'wsg-form-city', label: 'Ort', autocomplete: 'address-level2' },
    ];

    const applyWholesaleFieldOverrides = () => {
      wholesaleFieldOverrides.forEach((field) => {
        const element = document.getElementById(field.id);
        if (!element) return;
        if (element.getAttribute('placeholder') !== field.label) {
          element.setAttribute('placeholder', field.label);
        }
        if (element.getAttribute('aria-label') !== field.label) {
          element.setAttribute('aria-label', field.label);
        }
        if (field.autocomplete && element.getAttribute('autocomplete') !== field.autocomplete) {
          element.setAttribute('autocomplete', field.autocomplete);
        }
      });
    };

    document.title = window.location.pathname.endsWith('/ws-account-login')
      ? 'Återförsäljarinloggning – SmartDNA Protection Nordic AB'
      : 'Ansök om företagskonto – SmartDNA Protection Nordic AB';

    const replacementFor = (value) => wholesaleTextReplacements.get(normalizeText(value));
    const replacePreservingWhitespace = (originalValue, replacementValue) => {
      const leadingWhitespace = originalValue.match(/^\s*/)?.[0] || '';
      const trailingWhitespace = originalValue.match(/\s*$/)?.[0] || '';
      return `${leadingWhitespace}${replacementValue}${trailingWhitespace}`;
    };

    const translateWholesaleTextNodes = (root) => {
      if (!root) return;

      const textNodes = [];
      const walker = document.createTreeWalker(
        root,
        NodeFilter.SHOW_TEXT,
        {
          acceptNode(node) {
            const replacementValue = replacementFor(node.nodeValue);
            return replacementValue ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
          },
        }
      );

      while (walker.nextNode()) textNodes.push(walker.currentNode);

      textNodes.forEach((node) => {
        const replacementValue = replacementFor(node.nodeValue);
        if (replacementValue) node.nodeValue = replacePreservingWhitespace(node.nodeValue, replacementValue);
      });
    };

    const translateWholesaleAttributes = (root) => {
      if (!root?.querySelectorAll) return;

      root.querySelectorAll('[placeholder], [aria-label], [title], input[type="submit"], input[type="button"]').forEach((element) => {
        ['placeholder', 'aria-label', 'title'].forEach((attributeName) => {
          const attributeValue = element.getAttribute(attributeName);
          const replacementValue = replacementFor(attributeValue);
          if (replacementValue) element.setAttribute(attributeName, replacementValue);
        });

        if (element.matches('input[type="submit"], input[type="button"]')) {
          const replacementValue = replacementFor(element.value);
          if (replacementValue) element.value = replacementValue;
        }
      });
    };

    const translateWholesalePortalCopy = (root = document.body) => {
      translateWholesaleTextNodes(root);
      translateWholesaleAttributes(root);
      applyWholesaleFieldOverrides();
    };

    translateWholesalePortalCopy();

    let wholesaleTranslationScheduled = false;
    new MutationObserver(() => {
      if (wholesaleTranslationScheduled) return;
      wholesaleTranslationScheduled = true;
      window.requestAnimationFrame(() => {
        wholesaleTranslationScheduled = false;
        translateWholesalePortalCopy();
      });
    }).observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['placeholder', 'aria-label', 'title', 'value'],
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWholesaleAccountTranslation, { once: true });
  } else {
    initWholesaleAccountTranslation();
  }
})();
